/**
 * Formatea una fecha de PERÍODO como d/m/aaaa sin correrla de día.
 *
 * Los períodos se guardan como límites en UTC: el inicio es medianoche
 * (2026-06-01T00:00:00.000Z). Al pintarlo con toLocaleDateString, el navegador
 * lo convierte a hora local; en Colombia (UTC-5) esa medianoche cae a las 19:00
 * del día ANTERIOR y el corte de junio aparece arrancando el 31 de mayo.
 *
 * El fin no se nota porque es 23:59:59Z y restarle 5 horas lo deja en el mismo
 * día, así que el error sólo se ve en la fecha de inicio.
 *
 * Por eso se leen las partes en UTC: un límite de período es una fecha de
 * calendario, no un instante que deba traducirse a la zona del que mira.
 */
export const formatPeriodDate = (value) => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  return `${date.getUTCDate()}/${date.getUTCMonth() + 1}/${date.getUTCFullYear()}`;
};

/**
 * Nombre del mes de un límite de período, sin correrse al mes anterior.
 *
 * Mismo problema que formatPeriodDate: el 1 de julio a medianoche UTC cae en
 * junio si se interpreta en hora de Colombia, así que un comparativo contra
 * julio se anunciaba como "vs junio". `timeZone: 'UTC'` fuerza a leer la fecha
 * tal como se guardó.
 */
export const formatPeriodMonth = (value) => {
  if (!value) return null;

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleDateString('es-CO', {
    month: 'long',
    timeZone: 'UTC',
  });
};

/** Rango de un período, ya formateado. */
export const formatPeriodRange = (period) => {
  if (!period?.start || !period?.end) return null;
  return `${formatPeriodDate(period.start)} – ${formatPeriodDate(period.end)}`;
};

export const formatDateDayMonthYear = (dateString) => {
    // Extraer solo la parte de la fecha (YYYY-MM-DD) para evitar problemas de zona horaria
    const dateOnly = dateString.split('T')[0];
    const [year, month, day] = dateOnly.split('-');
    
    // Crear fecha usando los componentes individuales para evitar conversión de zona horaria
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };